module.exports = __webpack_public_path__ + "static/forklift-deddbcf8024696ff06c909a4ce22c644.jpg";